var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg076Email1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M501.182,176.53c-0.66-2.298-1.747-4.515-3.275-6.536c-1.132-1.496-2.433-2.788-3.856-3.869 c-3.848-4.766-8.255-9.106-13.161-12.9L299.907,13.311c-0.537-0.416-1.095-0.803-1.671-1.162 c-26.053-16.199-58.422-16.199-84.474,0c-0.576,0.358-1.134,0.746-1.671,1.162L31.109,153.225 c-19.452,15.038-31.065,38.694-31.065,63.281v215.509C0.045,476.119,35.926,512,80.031,512h245.957 c11.044,0,19.997-8.952,19.997-19.997s-8.952-19.997-19.997-19.997H80.031c-22.052,0-39.993-17.941-39.993-39.993V216.506 c0-12.293,5.807-24.121,15.532-31.641l180.097-139.23c12.624-7.465,28.042-7.465,40.666,0l174.496,134.899L276.414,312.479 c-12.679,7.537-28.194,7.529-40.868-0.023l-118.536-88.751c-8.84-6.62-21.373-4.818-27.992,4.022 c-6.619,8.84-4.818,21.372,4.022,27.992l119.295,89.318c0.461,0.345,0.937,0.67,1.425,0.975 c13.027,8.101,27.632,12.15,42.238,12.15c14.605,0,29.211-4.05,42.238-12.15c0.517-0.322,1.019-0.667,1.505-1.034l172.179-130.253 c0.027,0.592,0.041,1.185,0.041,1.78v41.539c0,11.044,8.952,19.997,19.997,19.997s19.996-8.952,19.996-19.997v-41.539 C511.955,202.388,508.125,188.578,501.182,176.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.087,383.182l-59.047-58.94c-11.617-11.617-30.522-11.617-42.129-0.012l-59.057,58.952 c-7.816,7.803-7.828,20.463-0.025,28.279c7.803,7.817,20.463,7.828,28.279,0.025l31.865-31.808v112.326 c0,11.044,8.952,19.997,19.997,19.997s19.997-8.952,19.997-19.997V379.678l31.865,31.808c3.903,3.896,9.015,5.844,14.127,5.844 c5.123,0,10.247-1.958,14.153-5.87C513.914,403.645,513.902,390.984,506.087,383.182z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg076Email1);
export default __webpack_public_path__ + "static/media/076-email-1.65623a97367a5ac4fc16049ff784dc50.svg";
export { ForwardRef as ReactComponent };